import React, { useState, useEffect } from 'react';
import { Alert } from 'antd';
import NavBar from './NavBar';
import Footer from './Footer';
import WhatsNewRibbon from '../components/Roadmap/WhatsNewRibbon';
import useBackendHealth from '../hooks/use_backend_health';
import { useNavCollapsed } from '../hooks/use_nav_collapsed';

function Layout({ children }) {
  const isBackendReachable = useBackendHealth();
  const { collapsed, toggleCollapsed } = useNavCollapsed();
  const [wasEverUnreachable, setWasEverUnreachable] = useState(false);
  const [errorDismissed, setErrorDismissed] = useState(false);

  useEffect(() => {
    if (!isBackendReachable) {
      setWasEverUnreachable(true);
      setErrorDismissed(false);
    }
  }, [isBackendReachable]);

  // app-shell offsets the page (and the fixed footer) by the sidebar's width
  // on wide screens; see --navbar-width in Navbar.css. Collapsing narrows it.
  return (
    <div className={`app-shell${collapsed ? ' app-shell--nav-collapsed' : ''}`}>
      {wasEverUnreachable && !errorDismissed && (
        <Alert
          message={isBackendReachable ? 'Connection restored.' : 'Cannot reach the backend — some features may be unavailable.'}
          type={isBackendReachable ? 'success' : 'error'}
          banner
          closable
          onClose={() => setErrorDismissed(true)}
          style={{ position: 'fixed', top: 0, left: 0, right: 0, zIndex: 9999 }}
        />
      )}
      <NavBar collapsed={collapsed} onToggleCollapsed={toggleCollapsed} />
      <div className="app-content">
        <WhatsNewRibbon />
        <main className="main-above-footer">
          {children}
        </main>
      </div>
      <Footer />
    </div>
  );
}

export default Layout;